import React from 'react';

const NextButtonSVG = () => (
  <svg width="38" height="74" viewBox="0 0 38 74" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.976074" width="38" height="73" rx="19" fill="white" />
    <path
      d="M17 42.476L22 37.476L17 32.476"
      stroke="#666"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default NextButtonSVG;



// WEBPACK FOOTER //
// ./src/components/icons/NextButtonSVG.js